import { useEffect } from "react";
import { Link } from "react-router-dom";

export default function Credits() {
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, []);
    return (
        <div style={{ padding: "2rem" }}>
            <Link to="/" className="safe-top-link">
    ← Home
</Link>

            <h1>Credits & Licences</h1>

            <p>
                Figure It Out makes use of original
                content together with selected
                third-party assets and services. We are
                grateful to the creators and organisations
                whose work has contributed to this
                project.
            </p>

            <h2>Original Content</h2>

            <p>
                Unless otherwise stated, the activities,
                text, software, graphics and overall
                design of Figure It Out were created by
                the developer and are protected by
                copyright.
            </p>

            <h2>Artificial Intelligence</h2>

            <p>
                Some activities use AI services to
                generate personalised educational
                feedback in response to user input.
            </p>

            <h2>Third-Party Images</h2>

            <p>
                Some images are used under licence,
                with permission, or are sourced from
                publicly available collections where
                permitted. Individual image credits are
                provided where required.
            </p>

            <h2>Audio</h2>

            <p>
                Audio recordings, sound effects and
                music are either original, licensed, or
                used in accordance with the applicable
                licence terms.
            </p>

            <h2>Fonts</h2>

            <p>
                Figure It Out may use open-source
                fonts distributed under their respective
                licences.
            </p>

            <h2>3D Models</h2>

            <p>
                Some activities may include 3D models
                created by third parties and used under
                licence. Attribution is provided where
                required.
            </p>

            <h2>Open-Source Software</h2>

            <p>
                Figure It Out is built using a number of
                open-source technologies, including
                React, Vite, Firebase and other software
                libraries made available under their
                respective licences.
            </p>

            <h2>Corrections</h2>

            <p>
                Every effort has been made to provide
                appropriate acknowledgement for
                third-party material. If you believe that
                any attribution is missing or incorrect,
                please contact the developer so that it
                can be corrected.
            </p>
        </div>
    );
}
